export function BrandMark({ size = 38 }: { size?: number }) {
  return (
    <svg
      className="brand-symbol"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <rect width="64" height="64" rx="18" fill="#5A2D82" />
      <path
        d="M17 47V17M47 47V17"
        fill="none"
        stroke="white"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path
        d="M18 36C25 24 39 24 46 36"
        fill="none"
        stroke="#EBCB6B"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path
        d="M23 47C23 36 31 30 42 29C50 28 53 23 52 16"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function BrandWordmark({ compact = false }: { compact?: boolean }) {
  return (
    <span className={compact ? "brand-wordmark compact" : "brand-wordmark"}>
      <span>Hair</span>
      <span>Bridge</span>
    </span>
  );
}
